import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { OnboardingLayout } from "@/components/layout/OnboardingLayout";
import { Eyebrow, PrimaryButton, TextLink } from "@/components/fionova/Primitives";
import { useTrialEligibility } from "@/components/billing/TrialTerms";

// Checkout was left without subscribing. Only ever returns to the saved results or the one current offer.
export default function PaymentCancel() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const offer = useTrialEligibility();
  const fromJourney = user?.journey_status === "completed";
  const midJourney = user?.journey_status === "active";
  const results = fromJourney ? "/journey/complete" : midJourney ? "/journey" : user?.has_discovery ? "/discovery/reveal" : "/";
  const resume = fromJourney ? "/journey/complete" : midJourney ? "/journey" : user?.has_discovery ? "/discovery/reveal#trial" : "/";
  return (
    <OnboardingLayout testId="page-payment-cancel" contentClassName="items-center justify-center py-12 text-center">
      <Eyebrow>No rush</Eyebrow>
      <h1 className="mt-4 text-3xl font-semibold leading-tight tracking-tight text-foreground">
        Your results are saved.
      </h1>
      <p className="mt-4 max-w-sm text-base leading-relaxed text-muted-foreground" data-testid="cancel-text">
        {fromJourney ? "Your journey and Ellie's closing reflection stay in your free account." : "Your Unsaid insights and Emotional X-Ray stay in your free account."}
        {offer?.headline ? ` Whenever you're ready: ${offer.headline}` : " Whenever you're ready, you can continue with FioNova."}
      </p>
      <div className="mt-8 w-full max-w-[300px]">
        <PrimaryButton data-testid="cancel-resume" onClick={() => navigate(resume)}>
          Return to my offer
        </PrimaryButton>
      </div>
      <div className="mt-4">
        <TextLink data-testid="cancel-reflection" onClick={() => navigate(results)} className="text-sm">Back to my reflection</TextLink>
      </div>
    </OnboardingLayout>
  );
}
